import { Component, Injector, Input, OnChanges, OnInit } from "@angular/core";
import { TranslationService } from "@services/translation.service";
import { enumNames } from "src/app/filters/enumNames.filter";
import { VSelectComponent } from "../v-select/v-select.component";
import "../v-select/v-select.component.scss";

@Component({
    selector: "v-enum-select",
    template: require("../v-select/v-select.component.html")
})
export class VEnumSelectComponent extends VSelectComponent implements OnInit, OnChanges {

    @Input() enum: any;
    @Input() enumName: string;

    constructor(
        protected readonly injector: Injector, protected readonly translationService: TranslationService) {
        super(injector, translationService);
    }

    ngOnInit() {
        this.populateItemsFromEnum();
    }

    ngOnChanges() {
        this.populateItemsFromEnum();
    }

    // ---

    private populateItemsFromEnum() {
        this.clearChildren();

        const enumNameFilter = enumNames();
        const filteredEnumNames = enumNameFilter(this.enum) as string[];

        filteredEnumNames.forEach(enumName => {
            this.registerSelectOption({
                label: this.translationService.tEnum(this.enum, this.enumName, this.enum[enumName]),
                value: this.enum[enumName]
            } as any);
        });
    }
}
